import { type StrictlyBasisPoints, add, strictlyZero, subtract } from "@vyne-shared/utils/currency";
import type { PatientHistoryResult } from "api/responses";

/** Get the amount to refund remaining. */
export const getRefundAmountRemaining = (result: PatientHistoryResult) =>
    subtract(
        Math.abs(result.amount ?? strictlyZero) as StrictlyBasisPoints,
        result.refunds?.reduce((acc, refund) => add(acc, refund.amount), strictlyZero) ?? strictlyZero,
    );
